import { Stack, Text } from '@vtex/admin-ui'
import { useIntl } from 'react-intl'
import { ListPriceKeys, type ListPrice } from 'typings'
import { IconListPrice } from '../../../../icons/IconListPrice'
import { Tag } from '../../../Tag'
import {
  Rule,
  RuleActions,
  RuleContent,
  RuleDescription,
  RuleIcon,
} from '../../RuleStack'
import { RuleDefaultActions } from '../../RuleStack/DefaultActions'
import { messages } from './messages'

type Props = {
  config: ListPrice | undefined
  onEdit: () => void
  onRemove: () => void
}

export function ListPriceView(props: Props) {
  const { config, onEdit, onRemove } = props

  const { $t } = useIntl()

  if (!config) return null

  const isDefined = config === ListPriceKeys.DEFINED

  return (
    <Rule onClick={onEdit}>
      <RuleIcon>
        <IconListPrice />
      </RuleIcon>

      <RuleDescription>
        {$t(messages.view.title, {
          b: (content: React.ReactNode) => (
            <Text variant="body">{content}</Text>
          ),
        })}
      </RuleDescription>

      <RuleContent>
        <Stack space="$space-2">
          <Tag>
            {$t(messages.view.description, {
              isDefined,
            })}
          </Tag>
          <Text variant="detail" tone="secondary">
            {$t(messages.editor[config].description)}
          </Text>
        </Stack>
      </RuleContent>

      <RuleActions>
        <RuleDefaultActions onEdit={onEdit} onRemove={onRemove} />
      </RuleActions>
    </Rule>
  )
}
